import { toSvg } from 'html-to-image'

// Капчер чека/отчёта в canvas для «Скачать»/«Поделиться» (CORE-474).
// Заменяет форк html2canvas: тот раскладывал текст вручную через Range-метрики,
// и на WebKit (iOS WKWebView) строки съезжали и низ чека обрезался.
// html-to-image рендерит клон через SVG foreignObject силами самого браузера,
// поэтому раскладка всегда совпадает с тем, что видит пользователь.
// SVG -> canvas конвертируем сами: toCanvas библиотеки ждёт img.decode(),
// который на больших data-URI SVG (инлайн шрифтов ~3-4 МБ) в Chromium
// может зависнуть навсегда; обычный onload надёжен в обоих движках.
const PIXEL_RATIO = 2

// Пауза перед финальной отрисовкой: двойной rAF + таймаут. Декод инлайновых
// шрифтов внутри SVG асинхронный, одного rAF не хватает
function warmUpDelay() {
  return new Promise((resolve) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setTimeout(resolve, 100)
      })
    })
  })
}

export default async function captureReceiptCanvas(el, { cropTop = 0 } = {}) {
  // На свежем старте шрифты документа могли ещё не догрузиться - клон
  // промерился бы fallback-шрифтом
  if (document.fonts && document.fonts.ready) {
    await document.fonts.ready.catch(() => {})
  }

  const width = el.offsetWidth
  const height = el.offsetHeight

  // Снимок всегда на белом фоне, а html-to-image инлайнит вычисленные цвета
  // живой темы: в тёмной теме текст вышел бы белым по белому. На время снимка
  // приводим цвета к светлой теме (класс в main.styl); в тёмной теме чек на
  // экране на это время кратко темнеет - терпимо, кнопка держит лоадер
  el.classList.add('re-capture-light')

  return toSvg(el, {
    backgroundColor: '#ffffff',
    // Чек центрируется контейнером (margin auto) - в клоне это сдвигает контент
    style: { margin: '0' },
  })
    .finally(() => {
      el.classList.remove('re-capture-light')
    })
    .then((svgDataUrl) => new Promise((resolve, reject) => {
      const img = new Image()
      img.onload = () => resolve(img)
      img.onerror = () => reject(new Error('receipt SVG failed to load'))
      img.src = svgDataUrl
    }))
    .then(async (img) => {
      const canvas = document.createElement('canvas')
      canvas.width = width * PIXEL_RATIO
      canvas.height = (height - cropTop) * PIXEL_RATIO
      const ctx = canvas.getContext('2d')
      ctx.fillStyle = '#ffffff'
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      // Рисуем дважды: img.onload не ждёт декода инлайновых (data-URI) шрифтов
      // внутри SVG, и самый первый капчер за сессию растеризуется fallback-шрифтом.
      // Первая отрисовка форсирует декод, вторая берёт шрифты уже из кэша рендерера.
      // Событий готовности у SVG-in-img нет, а img.decode() здесь виснет (см. выше)
      ctx.drawImage(img, 0, -cropTop * PIXEL_RATIO, width * PIXEL_RATIO, height * PIXEL_RATIO)
      await warmUpDelay()
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(img, 0, -cropTop * PIXEL_RATIO, width * PIXEL_RATIO, height * PIXEL_RATIO)
      return canvas
    })
}
